module.exports = __webpack_public_path__ + "7d7aff31d75f2f5977a407231bab6062.svg";